<div class="flex flex-col gap-sm px-md py-lg">

  <div class="flex flex-col gap-3xs">
    <span class="body-md text-content-text-body-secondary"
        [class.invisible]="compactView">Digitale Services mit svsGO</span>
    <span class="body-xs text-content-text-body-secondary flex gap-2xs items-center"
          [class.invisible]="compactView"><core-icon icon="info" size="sm"></core-icon>Login mit ID Austria notwendig</span>
  </div>
  @for (service of services; track service.link) {
    <core-utility-button [icon]="service.icon" [text]="compactView ? undefined : service.text"
                         [tooltip]="service.text"
                         [enableTooltip]="compactView"
                         placement="right"
                         (triggered)="openLink(service.link)"
                         role="link"
    ></core-utility-button>

  }
</div>
